export default __webpack_public_path__ + "static/ring-cfbb286cf609e2b50ebe5c753bc249af.png";